import React from "react";
import { Checkbox } from '@material-ui/core';
import InsertDriveFileOutlinedIcon from "@material-ui/icons/InsertDriveFileOutlined";
import MateDriveBreadcrumbs from "../Breadcrump/MateDriveBreadcrumbs";
import {useTranslation} from "react-i18next";
import {formatBytes} from "../../../../helpers/helper";


/**
 * @Description MateDrive File List design
 * @Param       data - folder data list
 * @Param       pathName - pathName
 * @Param       setSelectItem - func
 * @Param       selectItem - selected file or folder item
 * @Returns     div element
 * @Author      Kerem Karadeniz
 */
export default function FileList({data, pathName, setSelectItem, selectItem, setSelectedItems, selectedItems}) {
    const {t} = useTranslation();

    function handleClick(item, index) {
        setSelectItem(item);
        for (let i = 0; i < data.length; i++) {
            let elem = document.getElementById("mate-drive-file" + i);
            if (i === index) {
                if (elem !== undefined && elem !== null)
                    elem.style = "background-color: var(--calypso) ; color:white";
            } else {
                if (elem !== undefined && elem !== null)
                    elem.style = "background-color: transparent ; color:black";
            }
        }
    }

    const handleSelect = (e, item) => {
        if (e.target.checked) {
            setSelectedItems([...selectedItems, item]);
        }
        else {
            selectedItems.splice(selectedItems.indexOf(item), 1);
            setSelectedItems([...selectedItems]);
        }
    }

    return (
        <>
            <div>
                <MateDriveBreadcrumbs pathName={pathName} selectItem={selectItem}/>
            </div>
            <div className="matedrive-breadcrumbs">
                <table>
                    <tr>
                        <th></th>
                        <th>{t("CONTENT.MATE-DRIVE.FILE-NAME")}</th>
                        <th>{t("CONTENT.MATE-DRIVE.MODIFIED-AT")}</th>
                        <th>{t("CONTENT.MATE-DRIVE.SIZE")}</th>
                    </tr>

                    {data &&
                    data.length > 0 &&
                    data.map(function (item, index) {
                        return (
                            <>
                                {!item.is_dir ? (
                                    <tr
                                        key={index}
                                        id={"mate-drive-file" + index}
                                        onClick={() => handleClick(item, index)}
                                    >
                                        <td>
                                            <Checkbox color="default" size="small"
                                                onChange={(e) => handleSelect(e, item)}/>
                                        </td>
                                        <td>
                                            <InsertDriveFileOutlinedIcon
                                                style={{width: 18, height: 18}}
                                            />
                                            {item.name}
                                        </td>
                                        <td>
                                            {new Date(item.mod_time).toLocaleString(
                                                t("CONTENT.CREDENTIAL-TAB.LOCALE")
                                            )}
                                        </td>
                                        <td>{formatBytes(item.size, 2)}</td>
                                    </tr>
                                ) : null}
                            </>
                        )
                    })}
                </table>
            </div>
        </>
    );
}
